import React from 'react';

import { Box, Flex, useMediaQuery } from '@chakra-ui/react';
import { motion } from 'framer-motion';

import { animationFromRight } from '@/components/HomePage/data/animations';
import { WebPImage } from '@/components/WebPImage';

import { MediaQueryAmountsEnum } from '@/enum/mediaQueryAmounts.enum';

/**
 * Desktop version of Dashboard Section in Home page
 * @component
 * @example
 * <DashboardSectionDesktop />.
 */
const DashboardSectionDesktop: React.FC = () => {
  const [notADesktop] = useMediaQuery(MediaQueryAmountsEnum.isNotADesktop);

  return (
    <Flex
      as={motion.div}
      initial='hidden'
      overflow='hidden'
      sx={{
        backgroundImage: 'url("images/DashboardBackground.png")',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        h: '717px',
        color: 'app.white',
        justifyContent: 'center',
        position: notADesktop ? 'relative' : 'unset',
      }}
      viewport={{ amount: 0.2 }}
      whileInView='visible'
    >
      <Box
        as={motion.div}
        custom={4}
        position={notADesktop ? 'unset' : 'relative'}
        variants={animationFromRight}
        w={{ lg: '100%', xl: '1440px' }}
      >
        <WebPImage
          alt='Dashboard'
          commonPath='images/Dashboard.png'
          sx={
            !notADesktop
              ? {
                  position: 'absolute',
                  top: '125px',
                  right: '57px',
                }
              : {
                  position: 'absolute',
                  top: '125px',
                  right: '0',
                }
          }
          webpPath='images/webp/Dashboard_.webp'
        />
      </Box>
    </Flex>
  );
};

export default DashboardSectionDesktop;
